import { InjectionToken } from '@angular/core'

export const LANGUAGES = new InjectionToken<string[]>('languages')
